import dynamic from 'next/dynamic';
const IframeBlock = dynamic(() => import('./IframeBlock'));

export default IframeBlock;
